/* Fresca — FAQ: smooth one-at-a-time accordion + topic filter chips.
   Progressive enhancement: without this file the native <details> still open/close. */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EASE = 'cubic-bezier(.22, 1, .36, 1)';
  let refreshTimer;
  const refreshScroll = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); }, 120);
  };

  const init = (root) => {
    if (!root || root.dataset.faqReady) return;
    root.dataset.faqReady = '1';
    const items = Array.from(root.querySelectorAll('.fr-acc'));
    const bodyOf = (d) => d.querySelector('.fr-acc__body');
    const isOpen = (d) => d.open && !d.classList.contains('is-closing');

    const stop = (d) => { if (d._anim) { d._anim.cancel(); d._anim = null; } };

    const close = (d) => {
      if (!isOpen(d)) return;
      stop(d);
      const body = bodyOf(d);
      if (reduced || !body || !body.animate) { d.open = false; return; }
      d.classList.add('is-closing');
      const anim = body.animate([{ height: body.offsetHeight + 'px' }, { height: '0px' }], { duration: 380, easing: EASE });
      d._anim = anim;
      anim.onfinish = () => { d.open = false; d.classList.remove('is-closing'); d._anim = null; refreshScroll(); };
    };

    const open = (d) => {
      stop(d);
      d.classList.remove('is-closing');
      items.forEach((o) => o !== d && close(o));
      const body = bodyOf(d);
      const from = d.open && body ? body.offsetHeight : 0;
      d.open = true;
      if (reduced || !body || !body.animate) { refreshScroll(); return; }
      const to = body.scrollHeight;
      const anim = body.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 520, easing: EASE });
      d._anim = anim;
      anim.onfinish = () => { d._anim = null; refreshScroll(); };
    };

    items.forEach((d) => {
      const summary = d.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (isOpen(d)) close(d); else open(d);
      });
    });

    /* Topic filter chips */
    const chips = Array.from(root.querySelectorAll('[data-faq-filter]'));
    const scroller = root.querySelector('[data-faq-filters]');
    if (scroller && scroller.parentElement) {
      const edge = () => scroller.parentElement.classList.toggle('is-end', scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4);
      scroller.addEventListener('scroll', edge, { passive: true });
      window.addEventListener('resize', edge, { passive: true });
      edge();
    }
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const cat = chip.dataset.faqFilter;
      chips.forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', String(on));
      });
      let i = 0;
      items.forEach((d) => {
        const show = !cat || d.dataset.cat === cat;
        if (!show) {
          stop(d);
          d.classList.remove('is-closing', 'is-shown');
          d.open = false;
          d.hidden = true;
          return;
        }
        d.hidden = false;
        d.classList.add('is-in');
        if (!reduced) {
          d.classList.remove('is-shown');
          void d.offsetWidth; // restart the entrance animation
          d.style.animationDelay = (i * 0.05) + 's';
          d.classList.add('is-shown');
        }
        i++;
      });
      const bar = chip.parentElement;
      if (bar.scrollWidth > bar.clientWidth + 2) {
        const left = bar.scrollLeft + chip.getBoundingClientRect().left - bar.getBoundingClientRect().left - (bar.clientWidth - chip.offsetWidth) / 2;
        bar.scrollTo({ left: Math.max(0, left), behavior: reduced ? 'auto' : 'smooth' });
      }
      refreshScroll();
    }));
  };

  const boot = () => document.querySelectorAll('[data-faq]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
